module.exports = __webpack_public_path__ + "img/tertiary_9x2_z18.def378be.svg";